import { render, staticRenderFns } from "./EliminaDestino.vue?vue&type=template&id=5c30c20f&scoped=true"
import script from "./EliminaDestino.vue?vue&type=script&lang=js"
export * from "./EliminaDestino.vue?vue&type=script&lang=js"
import style0 from "./EliminaDestino.vue?vue&type=style&index=0&id=5c30c20f&prod&scoped=true&lang=css"
import style1 from "../main.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c30c20f",
  null
  
)

export default component.exports